module.exports = __webpack_public_path__ + "static/img/e6.4bd6f74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/e6.png
// module id = Ejcy
// module chunks = 1